const storageAvailable = () => {
  // feature detection adapted from MDN "Web Storage API"
  let storage;
  try {
    storage = window.localStorage;
    const x = '__________storage_test__________';
    storage.setItem(x, x);
    storage.removeItem(x);
    return { success: true };
  } catch (e) {
    return { success: false, message: e };
  }
};

const cleanupLocalStorage = (key, value, garbageCounter) => {
  // part of string used by 'bootstrap-typeahead' library
  // remove/update if/when `bootstrap-typeahead` no longer in codebase
  // we should only be removing Brandfolder items from localStorage
  const typeaheadKeyString = '__/api/brandfolder';
  let localStorageKeys = [];

  try {
    localStorageKeys = Object.keys(window.localStorage);
  } catch (e) {
    console.log('localStorage failed', e);
  }

  if (garbageCounter < 3) { // retry up to 3 times
    let keyToRemoveCounter = 0;

    localStorageKeys.forEach((keyToRemove) => {
      if (keyToRemove.includes(typeaheadKeyString) && keyToRemoveCounter < 10) { // remove up to 10
        keyToRemoveCounter += 1;
        try {
          window.localStorage.removeItem(keyToRemove);
        } catch (e) {
          console.log('localStorage failed', e);
        }
      }
    });

    setLocalStorage(key, value, garbageCounter + 1); // eslint-disable-line no-use-before-define
  }
};

export const setLocalStorage = (key, value, garbageCounter = 0) => {
  const storageStatus = storageAvailable();
  const errorName = storageStatus.message && storageStatus.message.name;

  if (storageStatus.success) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      cleanupLocalStorage(key, value, garbageCounter);
    }
  } else if (errorName === 'QuotaExceededError' || errorName === 'NS_ERROR_DOM_QUOTA_REACHED') {
    // localStorage is available, but is full or close to full
    cleanupLocalStorage(key, value, garbageCounter);
  }
};

export const getLocalStorage = (key) => {
  if (storageAvailable().success) {
    return window.localStorage.getItem(key);
  }

  return null; // null can be handled by JSON.parse(null) without erroring
};
